import { toNumber } from 'lodash'

export default {
    isKibanaAllowed: (_state, _getters, rootState) => {
        return (
            process.env.VUE_APP_ALLOWED_KIBANA_ACCOUNTS &&
            JSON.parse(process.env.VUE_APP_ALLOWED_KIBANA_ACCOUNTS).includes(toNumber(rootState.account.accountId))
        )
    }
}
